/**
 * One line offering to put the app on the Home Screen, and a way to never see
 * it again.
 *
 * It is a strip rather than a modal because it is not urgent and it must never
 * be in the way of reading mail. It is shown only to someone who is signed in
 * and looking at their mailbox: an install offer on a login screen is an offer
 * to install something the person has not yet decided they want.
 *
 * `lib/install.ts` holds the reasoning about why iOS gets a sentence and
 * Chromium gets a button.
 */

import * as install from "../lib/install";
import * as Icon from "./Icons";

export function InstallHint() {
  if (!install.shouldOfferInstall()) return null;

  return (
    <div class="install-hint" role="note">
      <span class="install-hint-icon" aria-hidden="true">
        <Icon.Bell />
      </span>
      <span class="install-hint-text">
        {install.isIOS ? (
          <>
            <strong>Add HydraMail to your Home Screen</strong> to get notifications when mail
            arrives. Tap Share, then <em>Add to Home Screen</em> — Safari will not send
            notifications to a tab.
          </>
        ) : (
          <>
            <strong>Install HydraMail</strong> to get notifications when mail arrives, and a window
            of its own.
          </>
        )}
      </span>
      {install.installable.value && (
        <button class="btn primary" onClick={() => void install.promptInstall()}>
          Install
        </button>
      )}
      <button class="btn ghost" onClick={() => install.dismiss()} aria-label="Dismiss, and do not ask again">
        Not now
      </button>
    </div>
  );
}
